var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCatalogIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5905 25.8902H21.5677C21.7623 25.8902 21.9193 25.7332 21.9193 25.5387V4.09092C21.9193 3.89639 21.7623 3.73937 21.5677 3.73937H16.7607C16.7607 0.272871 16.8193 0.322122 16.6154 0.174622C16.4842 0.0785266 16.6131 0.113684 0.431933 0.108997C0.237403 0.108997 0.0803833 0.266027 0.0803833 0.460547V21.9083C0.0803833 22.1028 0.237413 22.2598 0.431933 22.2598H5.23893V25.5388C5.23893 25.7334 5.39596 25.8904 5.59048 25.8904L5.5905 25.8902ZM0.783496 0.812722H14.2577L5.4805 3.75872C5.34456 3.80325 5.24143 3.93685 5.24143 4.09152V21.557H0.783683L0.783496 0.812722ZM21.2162 25.1877H5.942V4.44322H21.2162V25.1877ZM7.742 3.73997L16.0552 0.948472V3.73997H7.742Z",
    fill: "#EF6F6F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1905 6.49609H8.56475C8.37022 6.49609 8.2132 6.65312 8.2132 6.84764V10.4499C8.2132 10.6444 8.37023 10.8014 8.56475 10.8014H12.1905C12.385 10.8014 12.542 10.6444 12.542 10.4499V6.84764C12.542 6.65311 12.385 6.49609 12.1905 6.49609ZM11.8389 10.0983H8.9162V7.19909H11.8389V10.0983Z",
    fill: "#EF6F6F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1905 12.6631H8.56475C8.37022 12.6631 8.2132 12.8201 8.2132 13.0146V16.6169C8.2132 16.8114 8.37023 16.9684 8.56475 16.9684H12.1905C12.385 16.9684 12.542 16.8114 12.542 16.6169V13.0146C12.542 12.8201 12.385 12.6631 12.1905 12.6631ZM11.8389 16.2653H8.9162V13.3661H11.8389V16.2653Z",
    fill: "#EF6F6F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1905 18.8291H8.56475C8.37022 18.8291 8.2132 18.9861 8.2132 19.1807V22.7829C8.2132 22.9774 8.37023 23.1345 8.56475 23.1345H12.1905C12.385 23.1345 12.542 22.9774 12.542 22.7829V19.1807C12.542 18.9861 12.385 18.8291 12.1905 18.8291ZM11.8389 22.4314H8.9162V19.5321H11.8389V22.4314Z",
    fill: "#EF6F6F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.947 7.45215H18.594C19.058 7.45215 19.058 6.74902 18.594 6.74902H14.947C14.4829 6.74902 14.4829 7.45215 14.947 7.45215Z",
    fill: "#EF6F6F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5937 8.87012H14.9467C14.4827 8.87012 14.4827 9.57324 14.9467 9.57324H18.5937C19.0578 9.57324 19.0578 8.87012 18.5937 8.87012Z",
    fill: "#EF6F6F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5937 12.916H14.9467C14.4827 12.916 14.4827 13.6191 14.9467 13.6191H18.5937C19.0578 13.6191 19.0578 12.916 18.5937 12.916Z",
    fill: "#EF6F6F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5937 15.0371H14.9467C14.4827 15.0371 14.4827 15.7402 14.9467 15.7402H18.5937C19.0578 15.7402 19.0578 15.0371 18.5937 15.0371Z",
    fill: "#EF6F6F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5937 19.082H14.9467C14.4827 19.082 14.4827 19.7852 14.9467 19.7852H18.5937C19.0578 19.7852 19.0578 19.082 18.5937 19.082Z",
    fill: "#EF6F6F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5937 21.2031H14.9467C14.4827 21.2031 14.4827 21.9063 14.9467 21.9063H18.5937C19.0578 21.9063 19.0578 21.2031 18.5937 21.2031Z",
    fill: "#EF6F6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalogIconActive);
export default __webpack_public_path__ + "static/media/catalog_icon_active.ea0467b4c12349f00b421edc54695a64.svg";
export { ForwardRef as ReactComponent };